import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import { selectVulnTemplateDetail } from 'store/KnowledgeBase/selectors';
import ExpandableWrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ExpandableWrapper';
import useExpandable from 'Hooks/useExpandable';
import CVE from 'Screens/Contextualization/KnowledgeBase/components/ManualCreationModal/components/General/InputCVE';
import { updateVulnTemplate } from 'Screens/Contextualization/KnowledgeBase/actions/Actions';
import { Container } from './styled';

const TAB = 'general';
const ID = 'resolution';

const CVEEditor = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const vulnTemplate = useSelector(selectVulnTemplateDetail);
  const id = get(vulnTemplate, '_id', 0);
  const cve = get(vulnTemplate, 'cve', []);
  const isExpanded = useExpandable(TAB, ID, cve, id);

  const onAdd = (valueAdded) => {
    const newRefs = [...cve, valueAdded];
    dispatch(updateVulnTemplate(id, { cve: newRefs }));
  };

  const onRemove = (elementToRemove) => {
    const newRefs = cve.filter((pol) => pol !== elementToRemove);
    dispatch(updateVulnTemplate(id, { cve: newRefs }));
  };

  return (
    <ExpandableWrapper defaultValue={ isExpanded } id="cve" title={ intl.formatMessage({ id: 'manage.detail.tab.general.risk' }) } tab={ TAB }>
      <Container>
        <CVE
          width='100%'
          listData={ cve }
          onAdd={ onAdd }
          onRemove={ onRemove }
        />
      </Container>
    </ExpandableWrapper>
  );
};

export default CVEEditor;
